import React, { useEffect } from "react";
import { Footer } from "components/Footer";
import { HeaderWithNav } from "components/HeaderWithNav";
import { HeroSection } from "components/HeroSection";
import { useDynamicLanguage } from "hooks/useDynamicLanguage";
import heroImage from "assets/images/solutionPay.svg";
import { GetStartedSection } from "components/GetStartedSection";
import { LOCALE_STRINGS } from "constants/locales";
import { useScrollToElement } from "hooks/useScrollToElement";
import { ThreeCardFeatureSection } from "./components/ThreeCardFeatureSection";

export const SolutionsPay = () => {
  const language = useDynamicLanguage();
  useScrollToElement();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 80, 
        behavior: "smooth",
      });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <HeaderWithNav />
      <div id="page" />
      <main className="main-content-wrapper home-page__main">
        <HeroSection
          imageSrc={heroImage}
          language={language}
          getStarted="getStartedPay"
          titleKey="hero_payTitle"
          showStarted={true}
          showFooter={true}
        />

        <div 
          className="title-with-subtitle mb-12 text-center mx-auto w-full"
          style={{ maxWidth: "1050px", marginTop: "40px" }}
        >
          <h2 className="title" style={{ maxWidth: "100%" }}>
            {LOCALE_STRINGS[language]?.homePage_solutionsPay_title}
          </h2>
          <p className="text-small" style={{ maxWidth: "100%" }}>
            {LOCALE_STRINGS[language]?.homePage_solutionsPay_description}
          </p>
        </div>

        <ThreeCardFeatureSection language={language} />

        <GetStartedSection language={language} />
      </main>
      <Footer />
    </>
  );
};